/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/isIterable */
import{iterator as r}from"rxjs/dist/esm/internal/symbol/iterator";import{isFunction as t}from"rxjs/dist/esm/internal/util/isFunction";function m(o){return t(o?.[r])}export{m as isIterable};
//# sourceMappingURL=isIterable.mjs.map